export default {
	data: function () {
		return {
			subscriberTypes: [],
			defaultSubscriberTypeId: null,
			defaultSubscriberMaxPairedDeviceCount: null,
			defaultSubscriberParentalLockPin: null
		}
	},
	computed: {
		countries() {
			return [
				{id: 'CZE', text: this.$gettext('Česká republika')},
				{id: 'SVK', text: this.$gettext('Slovensko')},
				{id: 'CHE', text: this.$gettext('Švýcarsko')},
				{id: 'HUN', text: this.$gettext('Maďarsko')},
			]
		},
		subjectTypes() {
			return [
				{id: 'person', text: this.$gettext('Fyzická osoba')},
				{id: 'company', text: this.$gettext('Právnická osoba')},
			]
		},
		subjectTypesOptions() {
			return [
				{id: 'all', text: this.$gettext('Všichni')},
				{id: 'person', text: this.$gettext('Fyzická osoba')},
				{id: 'company', text: this.$gettext('Právnická osoba')},
			]
		},
		subscriberActiveOptions() {
			return [
				{id: 'all', text: this.$gettext('Všechny')},
				{id: 'active', text: this.$gettext('Aktivní')},
				{id: 'inactive', text: this.$gettext('Neaktivní')},
			]
		},
		operatorTypeOptions() {
			return [
				{id: null, text: this.$gettext('Všechny')},
				{id: 'testing', text: this.$gettext('Testovací')},
				{id: 'production', text: this.$gettext('Produkční')},
			]
		}
	},
	methods: {
		getFormFilterData(idOperator) {
			return this.entityService.getFormFilterData({'id_operator': idOperator})
				.then(data => {
					this.subscriberTypes = data.subscriber_types

					let operatorConfig = data.operator_configuration
					this.defaultSubscriberTypeId = operatorConfig.default_subscriber_type_id
					this.defaultSubscriberMaxPairedDeviceCount = operatorConfig.default_subscriber_max_paired_device_count
					this.defaultSubscriberParentalLockPin = operatorConfig.default_subscriber_parental_lock_pin
				})
		},
		getSubscriberTypeList(idOperator) {
			return this.entityService.getSubscriberTypeList({'id_operator': idOperator})
				.then(data => {
					this.subscriberTypes = data.subscriber_types
				})
		}
	}
}



// WEBPACK FOOTER //
// ./src/components/mixins/form-filter-data.js